<form [formGroup]="columnFilterForm">
  <div *ngFor="let column of activeFilterTableColumns" class="table-filter-grid">
    <div class="main">
      <div class="row">
        <ng-container [ngTemplateOutlet]="activeItem" [ngTemplateOutletContext]="{column: column}"></ng-container>
      </div>
    </div>
    <div class="button">
      <button type="button" class="btn btn-outline-secondary my-2 float-end" (click)="deselectFilter(column)">
        <i class="fa fa-trash-alt"></i>
      </button>
    </div>
  </div>
</form>
<div class="table-filter-grid">
  <div class="main">
    <div class="row">
      <ng-container [ngTemplateOutlet]="dropdownItem"></ng-container>
    </div>
  </div>
  <div class="button"></div>
</div>

<ng-template #dropdownItem let-column="column">
  <div class="col-12 col-md-4 my-1">
    <ng-multiselect-dropdown
      *ngIf="!column"
      [settings]="{
        singleSelection: true,
        idField: 'id',
        textField: 'text',
        disabledField:  'isDisabled',
        enableCheckAll: true,
        selectAllText: 'forms.multiselect.select_all' | translate,
        unSelectAllText: 'forms.multiselect.unselect_all' | translate,
        allowSearchFilter: true,
        clearSearchFilter: false,
        maxHeight: 300,
        itemsShowLimit: Infinity,
        limitSelection: Infinity,
        searchPlaceholderText: 'forms.multiselect.search_placeholder' | translate,
        noDataAvailablePlaceholderText: 'forms.multiselect.no_data_available' | translate,
        noFilteredDataAvailablePlaceholderText: 'forms.multiselect.no_filtered_data_available' | translate,
        closeDropDownOnSelection: true,
        showSelectedItemsAtTop: true,
        defaultOpen: false,
        allowRemoteDataSearch: true
      }"
      (onSelect)="selectFilter($any($event))"
      [data]="tableColumnOptions"
      class="w-100 single-selection"
      [id]="'unknown'"
      [formControl]="addingFilterFormControl"
    ></ng-multiselect-dropdown>

  </div>
  <div class="col-12 col-md-8 my-1"></div>
</ng-template>

<ng-template #activeItem let-column="column">
  <div class="col-12 col-md-4 my-1">
    <app-read-only-static
      [name]="column.name"
      [value]="('tables.' + tableConfig?.id + '.' + column.name) |translate"
    ></app-read-only-static>
  </div>
  <div class="col-12 col-md-8 my-1">
    <app-table-filter-input
      *ngIf="column && $any(columnFilterForm.controls)[column.name]"
      [tableConfig]="tableConfig"
      [column]="column"
      [inputFormControl]="$any(columnFilterForm.controls)[column.name]"
    ></app-table-filter-input>
  </div>
</ng-template>
